export default __webpack_public_path__ + "static/media/habi.cf4fc71a.svg";